import { DiagnosesFromBeanPart, DiagnosisTableBean } from './DiagnosesFormTab.types';

export const mapDiagnosesToDiagnosesFormBeanPart = (diagnoses: DiagnosisTableBean[]): DiagnosesFromBeanPart => {
   return {
      diagnoses: {
         search: null,
         value: diagnoses,
      },
   };
};
